import {
	getController,
	apiService as Service,
	type HpRequestOptional,
	type HpRequestPostPut,
} from '@/services/service'

const url = 'clientsettings'

type LogoRequest = {
	id: number
	type: string
	data: HpRequestOptional
}

export const settingsService = {
	...getController(url),
	update: (id: number, data: HpRequestPostPut<Api.ClientSettingUpdateInput>) =>
		Service.post<Api.ClientSettingFull>({
			url: `${url}/${id}`,
			...data,
			headers: {
				...data?.headers,
				'Content-Type': 'multipart/form-data',
			},
		}),

	get: (client_id: number) =>
		Service.get<Api.Collection<Api.ClientSettingFull>>({
			url: `${url}/?q[]=client_id&v[]=${client_id}`,
		}).then(({ data }) => {
			return data.data.length > 0 ? data.data[0] : null
		}),
	getLogo: ({ id, type = 'logo', data }: LogoRequest) =>
		Service.get({
			url: `${url}/${id}/binary_${type}`,
			...data,
			responseType: 'arraybuffer',
		}),
	deleteLogo: ({ id, type = 'logo' }: { id: number; type: string }) =>
		Service.delete({ url: `${url}/${id}/binary_${type}` }),
}

export default settingsService
